import 'moment-timezone';
import moment from 'moment';
import { useEffect, useState } from 'react';

import { DEFAULT_TIMEZONE } from '../constants';

interface CountdownProps {
  targetDate: number | string;
  timezone?: string | null;
}

export const useCountdown = ({ targetDate, timezone: initialTimezone }: CountdownProps) => {
  const timezone = initialTimezone ?? DEFAULT_TIMEZONE;
  const countDownDate = moment.utc(targetDate).valueOf();

  const [countDown, setCountDown] = useState(
    countDownDate - moment.utc(moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss')).valueOf(),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(
        countDownDate - moment.utc(moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss')).valueOf(),
      );
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown: number) => {
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const minutesL = Math.floor(minutes / 10);
  const minutesR = minutes % 10;

  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
  const secondsL = Math.floor(seconds / 10);
  const secondsR = seconds % 10;

  const diffInSeconds = countDown / 1000;

  return { days, hours, minutes, minutesL, minutesR, seconds, secondsL, secondsR, diffInSeconds };
};
